/*
   Artwork Modal
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { 
  currentJourneyStepProgress,
  journeyStepIdsForCurrentJourney,
  selectedArtworkForModal,
  selectedArtworkIdForModal,
  kioskMode
} from '../../selectors/journeyState-selectors'
import { setSelectedArtwork, setArtworkForModal } from '../../actions/artwork-actions'
import { setJourneyProgressStep } from '../../actions/journey-actions'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';
import closeButton from '../../assets/btn_close.png'
import '../../css/ArtworkModal.css'
import selectButton from '../../assets/btn_select.png'

class ArtworkModal extends React.Component {

   handleSelectArtwork() {
      const { journeyStepIds, setArtworkForModal, artwork, 
         setSelectedArtwork, currentJourneyStep, galleryId, 
         setJourneyProgressStep } = this.props

      if (artwork) {
         setSelectedArtwork(galleryId, artwork.id, currentJourneyStep)
         if (currentJourneyStep < (journeyStepIds.size - 1))
         {
            setJourneyProgressStep(galleryId, currentJourneyStep + 1)
         }
      }
      setArtworkForModal(galleryId, null)
   }

   render() {
      const { 
         artwork, galleryId, setArtworkForModal, 
         selectedArtworkIdForModal, kioskMode } = this.props

      let artworkUrl = ""
      if (artwork)
         artworkUrl = artwork.getIn(['artwork', (kioskMode ? 'large' : 'medium'), 'url'])

      return (
         <ReactCSSTransitionGroup
            transitionName="modal"
            transitionEnterTimeout={1000}
            transitionLeaveTimeout={200}>
            {((selectedArtworkIdForModal !== null) && (selectedArtworkIdForModal === artwork.get('id'))) &&
               <Hammer onTap={() => setArtworkForModal(galleryId, null)} options={tapOptions} >
                  <div 
                     key='modal'
                     className={'modal-container'} >
                     <div className={'artwork-modal'}>
                        <Hammer onTap={(e) => e.srcEvent.stopImmediatePropagation()} options={tapOptions} >
                           <div className={'artwork-img-container'} >
                              <img 
                                 className={artwork.get('orientation')}
                                 src={artworkUrl}
                                 alt={artwork.title}
                                 draggable={false}
                              />
                           </div>
                        </Hammer>
                        <Hammer onTap={(e) => e.srcEvent.stopImmediatePropagation()} options={tapOptions} >
                           <div className={'artwork-info-container'}>
                              <div className={'art-meta-container'}>
                                 <Hammer onTap={() => setArtworkForModal(galleryId, null)} options={tapOptions} >
                                    <img 
                                       src={closeButton} 
                                       className={'art-modal-exit-button'} 
                                       alt={'closeButton'}
                                       draggable={false} />
                                 </Hammer>
                                 <div className={'art-theme-blurb large-1'}>
                                    {artwork.description}
                                 </div>
                                 <Hammer onTap={() => this.handleSelectArtwork()} options={tapOptions} >
                                    <img src={selectButton} className={'add-to-journey large-1'} />
                                 </Hammer>
                                 <div className={'art-meta-data'} >
                                    <hr/>
                                    {artwork.artist && 
                                      <div className={'artist medium-2'}>
                                        {artwork.artist}
                                        {artwork.artist_dates && 
                                          <span className={'artist-dates'}> ({artwork.artist_dates})</span>
                                        }
                                      </div>}
                                    <div className={'origin medium-1'}>{artwork.origin}</div>
                                    <div className={'title medium-1'}>{artwork.title}</div>
                                    <div className={'year medium-1'}>{artwork.year}</div>
                                    <div className={'materials medium-1'}>{artwork.materials}</div>
                                    <div className={'credit small-1'}>{artwork.credit_line}, {artwork.accession_number}</div>
                                 </div>
                              </div>
                           </div>
                        </Hammer>
                     </div>
                  </div>
               </Hammer>
            }
         </ReactCSSTransitionGroup>
      );
      }
}

const mapStateToProps = (state, ownProps) => {
  return {
   currentJourneyStep: currentJourneyStepProgress(state, ownProps),
   journeyStepIds: journeyStepIdsForCurrentJourney(state, ownProps),
   artwork: selectedArtworkForModal(state, ownProps),
   selectedArtworkIdForModal: selectedArtworkIdForModal(state, ownProps),
   kioskMode: kioskMode(state, ownProps),
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
   setSelectedArtwork,
   setJourneyProgressStep,
   setArtworkForModal
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtworkModal)


// WEBPACK FOOTER //
// ./src/components/JourneyStep/ArtworkModal.js